import React from 'react';

const LinkedInIcon = ({ width = '40', height = '40' }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    className="fill-current text-techsicoGray-200 hover:text-white hover:shadow-2xl"
  >
    <path
      d="M33.667,60H10.333A8.343,8.343,0,0,1,2,51.667V28.334A8.343,8.343,0,0,1,10.333,20H33.667A8.343,8.343,0,0,1,42,28.334V51.667A8.343,8.343,0,0,1,33.667,60ZM26.848,40a2.492,2.492,0,0,1,1.855.586c.616.628.6,1.692.575,2.818,0,.207-.008.422-.008.633v8.881h5.652V43.233c0-2.766-.36-4.555-1.169-5.8-.992-1.529-2.723-2.273-5.29-2.273a8.921,8.921,0,0,0-3.545.7,4.245,4.245,0,0,0-2.107,1.726V35.159H17.966V52.922h5.651V44.04C23.618,41.548,24.158,40,26.848,40ZM9.085,35.159V52.922h5.651V35.159Zm2.422-8.881a3.23,3.23,0,1,0,3.229,3.23A3.273,3.273,0,0,0,11.507,26.277Z"
      transform="translate(-1.5 -19.5)"
    />
  </svg>
);

export default LinkedInIcon;
